const mEditionBillingAcademyChargesDropDownFilters = {
  mEditionBillingAcademyChargesDropDownFilters: {
    buttonPrimary: 'FILTRAR',

    buttonSecondary: {
      restartText: 'ACTUALIZAR'
    },

    input: {
      academiaUrl: {
        label: 'Url de la academia',
        placeholder: 'Escribe aquí la url de la academia'
      },

      descuento: {
        label: 'Código de Descuento',
        placeholder: 'Escribe aquí un código'
      },

      divisa: {
        label: 'Monedas'
      },

      email: {
        label: 'Razon social o Email',
        placeholder: 'razon social o email'
      },

      estado: {
        label: 'Estados de Pago'
      },

      fechaDesde: {
        label: 'Fecha Desde',
        placeholder: 'Desde - DD MM, AAAA'
      },

      fechaHasta: {
        label: 'Fecha Hasta',
        placeholder: 'Hasta - DD MM, AAAA'
      },

      medioPago: {
        label: 'Medios de Pago'
      },

      pais: {
        label: 'País',
        firstOption: 'Todos los países'
      },

      productos: {
        label: 'Productos'
      },

      type_product: {
        label: 'Tipo de Producto',
      }
    }
  }
}

export default mEditionBillingAcademyChargesDropDownFilters
